import { FC } from 'react';
import ViewUpload from '~/components/ViewUpload';
import { PermanentS3File } from '~/lib/Api.types';

type SignatureAnswerProps = {
    answer: PermanentS3File;
};
const SignatureAnswer: FC<SignatureAnswerProps> = ({ answer }) => {
    return (
        <div className="py-2">
            <ViewUpload file={answer.upload} name={answer.name} isImage={true} />
        </div>
    );
};
export default SignatureAnswer;
